export default "__VITE_ASSET__f88e10bf__"